import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Header />
      <Hero />
      <AppSection />
      <TopicsSection />
      <CarouselSection />
      <MediaSection />
      <FeaturesSection />
      <FaqSection />
      <AboutSection />
      <CommentsSection />
      <RankingSection />
      <CardsSection />
      <UpdatesSection />
      <IndexSection />
      <ContactSection />
      <Footer />
    </main>
  );
}